import { BackgroundColorTypes } from 'src/theme/adSales/colors'

export const isLightBackground = (backgroundColor: BackgroundColorTypes) =>
  backgroundColor === 'background.tertiary' || backgroundColor === 'background.quaternary'

export const isDarkBackground = (backgroundColor: BackgroundColorTypes) =>
  backgroundColor === 'background.primary' || backgroundColor === 'background.secondary'
